<template>
    <div>
        <b-form-textarea :rows="2" :name="`formData[${currentField.tagname}]`" v-model="textarea"
        :class="{'is-invalid' : error}" :placeholder="currentField.isPlaceholderVisible ? currentField.placeholder : ''"></b-form-textarea>
        <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
    </div>
</template>


<script>
export default {
  name: 'LongTextInput',
  props: ['currentField', 'error'],
  data() {
    return {
      textarea: ''
    }
  }
}
</script>
